import { Position } from './../../../models/api/vehicle-position.model';
import { FormGroup, FormControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-vehicle-edit',
  templateUrl: './vehicle-edit.component.html',
  styleUrls: ['./vehicle-edit.component.scss'],
})
export class VehicleEditComponent implements OnInit {
  @Input() vehicle: Position;
  @Output() onEdit = new EventEmitter<any>();

  deviceInformationForm: FormGroup;
  constructor() {}

  ngOnInit() {
    this.deviceInformationForm = new FormGroup({
      description: new FormControl(this.vehicle ? this.vehicle.name : ''),
    });
  }

  saveDeviceInformation() {
    this.onEdit.next(this.deviceInformationForm.value);
  }
}
